import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChartsStoreService } from '@app/core/features/charts-store/charts-store.service';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@app/shared/components/base/base/base.component';
import { CookieService } from 'ngx-cookie-service';
import { languageSupportYouTubeLinkIds } from '@app/constants';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CONFIG_BILLING_PAYMENT_SUPPORT, CONFIG_S63RAYMARINE_SUPPORT } from '@app/constants/config-common';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent extends BaseComponent implements OnInit {

  public s63RaymarineEmail: string;
  public webHelpEmail: string;
  public tollFreeNumber: string;
  public custHelpLink: string;
  public tidesandcurrentsLink: string;
  private billingsPaymentConfig = CONFIG_BILLING_PAYMENT_SUPPORT;
  private s63RaymarineConfig = CONFIG_S63RAYMARINE_SUPPORT;
  public listChartDownloadHelpText = [];
  public safeUrl: SafeResourceUrl;

  constructor(
    private translateService: TranslateService,
    private chartStoreService: ChartsStoreService,
    private cookieService: CookieService,
    private sanitizer: DomSanitizer
  ) {
    super();
  }

  ngOnInit() {
    this.getTranslateContent();
    this.chartStoreService.checkChangeLanguage
      .pipe(distinctUntilChanged())
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => this.getTranslateContent());
  }

  private getTranslateContent() {
    const dataLanguage = languageSupportYouTubeLinkIds.find(row => row.languageCode === this.cookieService.get('lang'));
    if (dataLanguage) {
      const youTubeUrl = `https://www.youtube.com/embed/${dataLanguage.videoId}?autoplay=0&loop=1`;
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(youTubeUrl);
    }

    this.translateService.get('SUPPORT.CHARTS_DOWNLOAD_HELP.TEXT')
      .subscribe((data) => {
        this.listChartDownloadHelpText = data;
      });

    this.webHelpEmail = `<a href='mailto:${this.billingsPaymentConfig.webHelpEmail}'
                          style='${this.billingsPaymentConfig.cssLink}'>
                            ${this.billingsPaymentConfig.webHelpEmail}</a>`;

    this.tollFreeNumber = `<a href='tel:${this.billingsPaymentConfig.tollFreeNumber}'
                            style='${this.billingsPaymentConfig.cssLink}'>
                              ${this.billingsPaymentConfig.tollFreeNumber}</a>`;

    this.custHelpLink = `<a href='${this.billingsPaymentConfig.custHelp}'
                          style='${this.billingsPaymentConfig.cssLink}'>
                            ${this.billingsPaymentConfig.custHelp}</a>`;

    this.tidesandcurrentsLink = `<a href='${this.billingsPaymentConfig.tidesandcurrentsLink}' target='_blank'
                                    style='${this.billingsPaymentConfig.cssLink}'>
                                      ${this.billingsPaymentConfig.tidesandcurrentsLink}</a>`;

    this.s63RaymarineEmail = `<a href='mailto:${this.s63RaymarineConfig.s63RaymarineEmail}'
                                style='${this.s63RaymarineConfig.cssLink}'>
                                  ${this.s63RaymarineConfig.s63RaymarineEmail}</a>`;
  }
}
